import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getWindowParent } from 'lib/Utils';

declare global {
    interface Window {
        lang: string;
    }

    interface Translations {
        [keyTrans: string]: {
            [keyLang: string]: string
        };
    }
}

const searchParams = new URLSearchParams(document.location.search);
const parentLang = searchParams.get('lang');

if (parentLang !=null) {
    window.lang = parentLang;
} else {
    window.lang = "de";
}

/*
const parent = getWindowParent();
if (parent) {
    window.lang = parent.document.documentElement.lang;
    window.document.documentElement.lang = window.lang;
} else {
    window.lang = "de";
}
*/

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
